
export default class AddCostPoolRequest {
    public name: string | null = null;

    public externalId: string | null = null;
    
    public description: string | null = null;
}